import { cancelableRequestFactory } from '../cancelableRequests/cancelableRequestFactory';
import { RequestConfig, RequestPerformer } from '../types';

export const authorizedRequestFactory = (
  buildAuthConfig: (config: RequestConfig) => RequestConfig,
): RequestPerformer => {
  const cancelableRequest = cancelableRequestFactory();

  const authorizedRequest = async <ResponseType>(config: RequestConfig) => {
    const authConfig = buildAuthConfig(config);
    const response = await cancelableRequest<ResponseType>(authConfig);
    return response;
  };

  return authorizedRequest;
};
